// extracted by mini-css-extract-plugin
export default {"Backdrop":"Backdrop_Backdrop__iVu8d","Dark":"Backdrop_Dark__HwC-c","Light":"Backdrop_Light__dIUtO"};